export default __webpack_public_path__ + "static/media/navigationbanner.89393c9a.jpg";